var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-presentation-mode-alert bsx-m-auto"},[_c('ed-icon',{staticClass:"alert-icon",attrs:{"icon":"users-solid"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }